<template>
    <form :action="passwordResetUrl" method="post" ref="changePasswordForm" @submit.prevent>
        <slot name="csrf" ></slot>
        <slot name="input-next" ></slot>

        <div class="form-row">
            <div class="form-group col">
                <label class="control-label">{{ i18n.password }}</label>
                <input
                    name="password"
                    autocomplete="new-password"
                    v-model.trim="password"
                    :type="isPasswordVisible ? 'text': 'password'"
                    class="form-control"
                    :class="passwordError ? 'is-invalid' : ''"
                    :placeholder="i18n.password"
                >
                <span @click="onEyeClick" class="fa fa-fw field-icon toggle-password" :class="isPasswordVisible ? 'fa-eye' : 'fa-eye-slash'"></span>
                <div class="invalid-feedback" v-if="passwordError">
                    {{ passwordError }}
                </div>
            </div>
        </div>
        <div>
            <div class="progress">
                <div class="progress-bar" :class="progressStatus.progressClass"></div>
            </div>
        </div>

        <div
          id="message"
          class="signup-password-info"
        >
          <h6>
            {{ i18n.mustHave }}
          </h6>
          <ul>
            <li :class="progressStatus.lower ? 'valid' : 'invalid'" v-html="i18n.lowercase" />
            <li :class="progressStatus.upper ? 'valid' : 'invalid'" v-html="i18n.uppercase" />
            <li :class="progressStatus.number ? 'valid' : 'invalid'" v-html="i18n.number" />
            <li :class="progressStatus.length ? 'valid' : 'invalid'" v-html="i18n.minCharacters" />
          </ul>
        </div>
                        
        <ui-alert v-if="generalError" type="error" :title="generalError" />

        <div class="form-row">
            <div class="form-group col">
                <turnstile
                  v-if="captchaType === 'turnstile'"
                  :class="{ 'border-error error-anchor': !isRecaptchaFilled }"
                  :sitekey="newCaptchaSiteKey"
                  :language="language"
                />
                <hcaptcha
                  v-else-if="captchaType === 'hcaptcha'"
                  :class="{ 'border-error': !isRecaptchaFilled }"
                  :sitekey="newCaptchaSiteKey"
                  :language="language"
                />
                <recaptcha
                  v-else
                  :class="{ 'border-error': !isRecaptchaFilled }"
                  :sitekey="captchaSiteKey"
                  :language="language"
                />
            </div>
        </div>
        <ui-button
            @click="validate"
            block
            uppercase
            appearance="primary"
            :disabled="!isRecaptchaReady || submittedForm"
            :label="i18n.savePassword"
        />
    </form>
</template>

<script>
// import Translations from "./insert-me-to-translate.vue";

import Recaptcha from './recaptcha';
import Hcaptcha from './hcaptcha';
import Turnstile from './turnstile';
import { mapGetters } from "vuex";

export default {
    props: {
        initPassword: String,
        initPasswordError: String,
        initGeneralError: String,
        passwordResetUrl: {
            type: String,
            required: true,
        },
        captchaType: String,
        captchaSiteKey: String,
        newCaptchaSiteKey: String,
        language: {
            type: String,
            required: true,
        },
    },
    components: {
        Recaptcha,
        Hcaptcha,
        Turnstile,
        UiButton: () => import(/* webpackChunkName: "chunk-ui-button" */ './ui/ui-button.vue'),
        UiAlert: () => import(/* webpackChunkName: "chunk-ui-alert" */ './ui/ui-alert.vue'),
    },
    data: function(){
        return  {
            isPasswordVisible: false,
            password: this.initPassword,
            passwordError: this.initPasswordError,
            isRecaptchaFilled: true,
            generalError: this.initGeneralError || '',
            submittedForm: false,
            i18n: {
                password: gettext('Password'),
                mustHave: gettext('Your password must have:'), 
                lowercase: gettext('A <b>lowercase</b> letter'),
                uppercase: gettext('A <b>uppercase</b> letter'),
                number: gettext('A <b>number</b>'),
                minCharacters: gettext('Minimum <b>8 characters</b>'),
                savePassword: gettext('Save Password'),
            }

        };
    },
    computed:{
        ...mapGetters({
            isRecaptchaReady: 'ui/recaptcha/isReady',
            recaptchaResponse: 'ui/recaptcha/response',
        }),

        progressStatus() {
            const conditions = {
                length: this.password.length>=8,
                number: this.password.match(/\d/),
                lower: this.password.match(/[a-z]/),
                upper: this.password.match(/[A-Z]/),
            };

            const satisfiedCount = Object.values(conditions).filter(Boolean).length;
            conditions.progressClass = satisfiedCount > 0 ? `p${satisfiedCount * 25}` : '';
            return conditions;
        },
    },
    methods: {
        onEyeClick(){
            this.isPasswordVisible = !this.isPasswordVisible;
        },
        validate() {
            this.passwordError = '';
            this.isRecaptchaFilled = !!this.recaptchaResponse;
            const trimmedPassword = this.password.trim();

            if(trimmedPassword && this.isRecaptchaFilled) {
                this.submittedForm = true;
                this.$refs.changePasswordForm.submit()
                return true;
            } else {
                if(!trimmedPassword){
                    this.passwordError = gettext('Please fill in this field');
                }else{
                    if(this.password.length < 8 || !this.password.match(/\d/) || !this.password.match(/[a-z]/) || !this.password.match(/[A-Z]/)){
                        this.passwordError = gettext('Password must be at least 8 characters long and must have at least one lowercase letter, one UPPERCASE letter and one number.')
                    }
                }

            }
        }
    }
};
</script>
